class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
  }

  connectedCallback() {
    this.container = this.firstElementChild;
    this.productList = this.querySelector("#mini-cart-just-added");
    this.template = this.querySelector("#product-item-template")?.content;
    this.cartSubtotal = this.querySelector("#mini-cart-totals .amount bdi");

    if (!this.container || !this.productList || !this.template) {
      console.error("Required mini-cart elements not found");
      return;
    }

    // Create and attach overlay
    this.overlay = document.createElement("div");
    this.overlay.id = "mini_cart_overlay";
    this.after(this.overlay);

    // Attach listeners
    this.overlay.addEventListener("click", () => this.toggleCart());
    this.querySelector("i#close_mini_cart")?.addEventListener("click", () => this.toggleCart());
    document.addEventListener("cart:update", this.handleCartUpdate);
  }

  async handleCartUpdate(event) {
    const items = event.detail?.newItems || [];

    if (items.length > 0) {
      this.renderItems(items);
      await this.updateSubtotal();
      this.open();
    }
  }

  renderItems(items) {
    if (!this.productList) return;
    this.productList.innerHTML = "";

    items.forEach((item) => {
      if (!item?.id) return;
      const element = this.createItemElement(item);
      if (element) this.productList.appendChild(element);
    });
  }

  createItemElement(item) {
    if (!item) return null;
    const element = document.importNode(this.template, true);

    // Update image and links
    const imageAnchor = element.querySelector(".image-contain a");
    const image = element.querySelector(".image-contain img");
    const productName = element.querySelector(".product-name");
    const productLink = element.querySelector(".product-link");

    if (imageAnchor) imageAnchor.href = item.url || "#";
    if (image && item.featured_image) {
      image.src = item.featured_image.url || "";
      image.alt = item.featured_image.alt || "";
    }
    if (productName) productName.href = item.url || "#";
    if (productLink) {
      productLink.href = item.url || "#";
      productLink.title = item.product_title || "";
      productLink.appendChild(document.createTextNode(`${item.vendor || ""} ${item.product_title || ""}`));
    }

    // Update variations
    const variations = element.querySelector(".variation");
    if (variations && item.properties) {
      Object.entries(item.properties).forEach(([key, value]) => {
        if (!key.startsWith("_")) {
          const className = `variation-${key.replace(/\s+/g, "")}`;

          const dt = document.createElement("dt");
          dt.className = className;
          dt.textContent = `${key}:`;

          const dd = document.createElement("dd");
          dd.className = className;
          const p = document.createElement("p");
          p.textContent = value || "N/A";
          dd.appendChild(p);

          variations.appendChild(dt);
          variations.appendChild(dd);
        }
      });
    }

    // Update quantity and price
    const qtyValue = element.querySelector(".qty-value");
    const price = element.querySelector(".woocommerce-Price-amount bdi");

    if (qtyValue) qtyValue.textContent = item.quantity || "1";
    if (price) {
      const productData = JSON.parse(document.getElementById("product-data").textContent);
      if (productData.customer_email && productData.logged_in_price) {
        price.textContent = `$${productData.logged_in_price}`;
      } else {
        price.textContent = this.formatMoney(item.price || 0);
      }
    }

    return element;
  }

  async updateSubtotal() {
    if (!this.cartSubtotal) return;
    try {
      const response = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await response.json();
      this.cartSubtotal.textContent = this.formatMoney(cart.total_price);
    } catch (error) {
      console.error("Error updating subtotal:", error);
    }
  }

  formatMoney(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount / 100);
  }

  toggleCart() {
    this.container?.classList.toggle("open");
    this.overlay?.classList.toggle("open");
  }

  open() {
    this.container?.classList.add("open");
    this.overlay?.classList.add("open");
  }
}

customElements.define("mini-cart", MiniCart);
